// extracted by mini-css-extract-plugin
export var currencyInput = "_nx-1";
export var currencySymbol = "_nx-0";